module.exports = __webpack_public_path__ + "img/learn-bg-clovers.b19a9ea6.svg";